export default "__VITE_ASSET__CaTbZwqn__"